<template>
    <header>
      <div class="container">
        <div class="header">
          <img
            :src="isDarkMode ? logoWhite : logoColor"
            alt="AEPD Logo"
            class="header__logo"
          />
          
          <div class="header__tool">
            <img 
                v-if="icon" 
                :alt="`${title} - ${description}`" 
                :src="isDarkMode ? iconDark : icon" 
                class="header__tool-icon transition-icon"
            />
            <div class="header__tool-info">
              <h1 class="header__tool-title h4">{{ title }}</h1>
              <p class="header__tool-description">{{ description }}</p>
            </div>
          </div>

          <section class="header__actions">
            <DarkModeToggle @darkModeToggled="updateDarkMode"/>
            <LanguageSelector />        
            <HelpPanel v-if="sharedService.sharedState.step != 1" />
          </section>
        </div>
      </div>
    </header>
</template>

<script>
  import DarkModeToggle from './DarkModeToggle.vue';
  import HelpPanel from './HelpPanel.vue';
  import LanguageSelector from './LanguageSelector.vue';

  import logoColor from '../assets/AEPD_color_original_logo.svg';
  import logoWhite from '../assets/AEPD_white_original_logo.svg';
  import sharedService from '@/services/sharedService';

  export default {
      name: 'AppHeader',
      props: {
        title: {
          type: String,
          required: true
        },
        description: {
          type: String,
          required: true
        },
        icon: {
          type: String,
          required: true
        },
        iconDark: {
          type: String,
          required: true
        }
      },
      data() {
          return {
              isDarkMode: false,
              logoColor,
              logoWhite,
              sharedService
          };
      },
      mounted() {
          const savedTheme = localStorage.getItem('theme');
          this.isDarkMode = savedTheme === 'dark'; 
          document.documentElement.setAttribute('data-theme', savedTheme || 'light');       
      },
      methods: {
        updateDarkMode(isDarkMode) {
            this.isDarkMode = isDarkMode;
        }
      },
      components: {
          DarkModeToggle,
          LanguageSelector,
          HelpPanel
      }
  }
</script>
